/* De speler komt pas bij een klik. Drie ingesloten spelers die meteen laden is
   bijna een megabyte aan scripts van derden vóór iemand iets heeft aangeklikt,
   plus cookies van een ander domein. */
(function(){
  document.addEventListener('click', e => {
    const knop = e.target.closest('.veld__start');
    if (!knop) return;
    const bron = knop.dataset.insluit;
    if (!bron) return;
    const doek = document.createElement('div');
    doek.className = 'veld__doek snede veld__speelt';
    doek.innerHTML =
      '<iframe src="' + bron + '" title="Film" loading="lazy" allowfullscreen ' +
      'allow="autoplay; fullscreen; picture-in-picture"></iframe>';
    knop.replaceWith(doek);
  });
})();
